var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhilanthropy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Donation-Charity-Hand-Give-Heart--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Donation Charity Hand Give Heart Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.08 8.72a2.18 2.18 0 0 0 -1.63 -1.2 2.21 2.21 0 0 0 -1.92 0.62l-0.12 0.12 -0.12 -0.12a2.22 2.22 0 0 0 -3.56 0.58 2.22 2.22 0 0 0 0.41 2.55l2.91 3a0.48 0.48 0 0 0 0.36 0.15 0.51 0.51 0 0 0 0.36 -0.15l2.89 -3a2.21 2.21 0 0 0 0.42 -2.55Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0h-6.71a7.74 7.74 0 0 0 -2 0.32 6.61 6.61 0 0 0 -4.54 5.58 0.51 0.51 0 0 0 0.12 0.39 0.46 0.46 0 0 0 0.36 0.17l2.34 0.08a0.53 0.53 0 0 0 0.47 -0.29 3 3 0 0 1 2.59 -1.8 1.46 1.46 0 0 1 1.09 0.38l0.83 0.73a0.9 0.9 0 0 1 0.3 0.63 0.88 0.88 0 0 1 -0.26 0.65l-1.41 1.41a1.53 1.53 0 0 0 0 2.17 1.51 1.51 0 0 0 1.08 0.45 1.5 1.5 0 0 0 1.06 -0.43l2.93 -2.58a2.25 2.25 0 0 1 1.6 -0.66h0.15a0.5 0.5 0 0 0 0.5 -0.5V0.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.75V23a1 1 0 0 0 2 0v-7.25a1 1 0 0 0 -2 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 16v6.5a0.5 0.5 0 0 0 0.5 0.5h10.76a2.24 2.24 0 0 0 2.24 -2.24v-0.26a1 1 0 0 0 -1 -1H6.37a0.63 0.63 0 0 1 0 -1.25H8.9a1 1 0 0 0 0.92 -1.39 2.23 2.23 0 0 0 -2.06 -1.36H3.5a0.5 0.5 0 0 0 -0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhilanthropy);
export default ForwardRef;